<div class="pb-3">
    <app-card-table
        [tableTitle]="'service.nursingDiagnoses.title'"
        [columns]="columns"
        translatePrefix="service.nursingDiagnoses."
        [hideCheckboxes]="true"
        [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [serviceId] }]]"
        [gridData]="$any(store.data.serviceNursingCareDiagnosisCodes$ | async)"
        [refreshCallback]="store.api.getServiceNursingCareDiagnosisCodes"
        [showSearch]="true"
        [defaultSorters]="[{ column: 'code', direction: 'ASC' }]"
        (detailCallback)="goTo($event)"
        (createCallback)="goTo()"
        (deleteCallbackWithEvent)="deleteDiagnosis($event)"
        [showCreate]="store2.isAllowed('service.update')()"
        [showDetail]="store2.isAllowed('service.update')()"
        [showDelete]="store2.isAllowed('service.update')()"
    >
    </app-card-table>
</div>
